import { useCopilotMeta } from '@customerio/hydra-copilot/react';
import { Label, Tooltip } from '@customerio/pluma-components/react';
import { AccountFeatureFlag, hasFeatureFlag } from '@/services/auth/feature-flags';
import { useCopilotSessionContext } from './session-provider';
import { shouldShowAgentBetaLabel } from '../utils/agent-beta-label-visibility';

const AGENT_BETA_TOOLTIP =
  'Agent is in beta while we refine the experience. Your feedback helps us make it more useful for your team.';

/**
 * Purple Beta label with tooltip; renders nothing when the session is named or Agent v2 is off.
 */
export function AgentBetaLabel() {
  const session = useCopilotSessionContext();
  const meta = useCopilotMeta(session);
  const isVisible = shouldShowAgentBetaLabel(meta.name, hasFeatureFlag(AccountFeatureFlag.AiAssistantV2));

  if (!isVisible) {
    return null;
  }
  return (
    <Tooltip content={AGENT_BETA_TOOLTIP} placement="top" isCustom={true}>
      {(context) => (
        <Label color="purple" ref={context.reference.setReference} {...context.reference.getReferenceProps()}>
          Beta
        </Label>
      )}
    </Tooltip>
  );
}
